export const COMMON_STRINGS = {
  DESTINATION_RIDE: "DESTINATION_RIDE",
  ORIGIN_RIDE: "ORIGIN_RIDE",
  KIA: "Kempegowda International Airport",
  WARNING_TEXT: " 🚕 CURRENTLY ONLY IN BANGALORE! 🚕",
};
